import React from 'react';
import PropTypes from 'prop-types';
import ArticleListItem from './ArticleListItem';
import ListHeader from '../ListHeader';

const ArticleList = ({articles}) => (
  <div>
    <ListHeader href="/article/77-welcome-to-teamgantt" text="Articles" />
    <ul>
      {articles.map(article => (
        <li key={article.id}>
          <ArticleListItem article={article} />
        </li>
      ))}
    </ul>
  </div>
);

ArticleList.propTypes = {
  articles: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    }).isRequired
  ).isRequired,
};

export default ArticleList;



// WEBPACK FOOTER //
// ./src/components/articles/ArticleList.js